import store from 'Store';
import { dispatch } from 'Models/utils/event-bus';

export default function flyouts (element) {
    let elementClicked = false;
    let storedFlyout = null;
    const documentElement = document.documentElement;
    const bodyElement = document.documentElement.querySelector('body');
    const flyoutToggleAttribute = 'data-toggle-flyout';

    const states = {
        isFlyoutOpen: 'is-flyout-open',
        isFlyoutActive: 'is-flyout-active',
    };

    function init () {
        addWatchers();
    }

    function addWatchers () {
        store.watch(
            state => state.activeFlyout,
            activeFlyout => {
                updateActiveFlyout(activeFlyout);
            },
            { immediate: false },
        );
    }

    function addListeners () {
        element.addEventListener('click', elementClickHandler);
        document.documentElement.addEventListener('click', documentClickHandler);
    }

    function removeListeners () {
        element.removeEventListener('click', elementClickHandler);
        document.documentElement.removeEventListener('click', documentClickHandler);
    }

    function documentClickHandler () {
        if (!elementClicked && store.getters.getActiveFlyout === storedFlyout) {
            store.commit('setActiveFlyout', null);
        }
    }

    function elementClickHandler () {
        elementClicked = true;
        setTimeout(() => {
            elementClicked = false;
        }, 10);
    }

    function updateActiveFlyout (flyout) {
        let openFlyoutTimeout;

        // if IE 11
        if (bodyElement.classList.contains('browser-explorer')) {
            openFlyoutTimeout = 50;

        //  if normal browser
        } else {
            openFlyoutTimeout = 0;
        }

        if (flyout) {
            // if IE 11
            if (bodyElement.classList.contains('browser-explorer')) {
                element.classList.add('is-block');
            }
            setTimeout(() => {
                element.setAttribute('data-flyout', flyout);
                documentElement.classList.add(states.isFlyoutOpen);
                requestAnimationFrame(() => {
                    addListeners();
                });
                dispatch('flyout-opened');
                console.log('dispatched');
            }, openFlyoutTimeout);
        } else {
            element.removeAttribute('data-flyout');
            documentElement.classList.remove(states.isFlyoutOpen);
            removeListeners();

            // if IE 11
            if (bodyElement.classList.contains('browser-explorer')) {
                setTimeout(() => {
                    element.classList.remove('is-block');
                }, 100);
            }
        }
        markActiveFlyoutLinks(flyout);
        setTimeout(() => {
            storedFlyout = flyout;
        }, 10);
    }

    function markActiveFlyoutLinks (flyout) {
        // remove active class from the current active flyouts (if any)
        const activeFlyoutToggles = document.querySelectorAll(`[${flyoutToggleAttribute}].${states.isFlyoutActive}`);
        activeFlyoutToggles.forEach(activeFlyoutToggle => {
            activeFlyoutToggle.classList.remove(states.isFlyoutActive);
        });

        // add active classes to new active flyout (if specifed)
        if (!flyout) {
            return false;
        }
        const flyoutToggles = document.querySelectorAll(`[${flyoutToggleAttribute}="${flyout}"]`);
        flyoutToggles.forEach(flyoutToggle => {
            flyoutToggle.classList.add(states.isFlyoutActive);
        });
    }

    init();
}
